import {Currency, Ether, NativeCurrency, Token} from '@uniswap/sdk-core'
import { SupportedChainId } from 'constants/chains'
import invariant from "tiny-invariant";

export const NATIVE_CHAIN_ID = 'NATIVE'

// When decimals are not specified for an ERC20 token
// use default ERC20 token decimals as specified here:
// https://docs.openzeppelin.com/contracts/3.x/erc20
export const DEFAULT_ERC20_DECIMALS = 18

export const USDC_CRAT = new Token(
  SupportedChainId.CRAT,
  '0xe5AB6881Fe3D22eCc213E5a56A9523a8576bD8D7',
  6,
  'USDC',
  'USD Coin'
)
export const USDC_CRAT_TESTNET = new Token(
  SupportedChainId.CRAT_TESTNET,
  '0xe5AB6881Fe3D22eCc213E5a56A9523a8576bD8D7',
  6,
  'USDC',
  'USDC'
)
// export const DAI_CRAT = new Token(
//   SupportedChainId.CRAT,
//   '0x1AF3F329e8BE154074D8769D1FFa4eE058B1DBc3',
//   18,
//   'DAI',
//   'Dai token'
// )
// export const DAI_CRAT_TESTNET = new Token(
//   SupportedChainId.CRAT_TESTNET,
//   '0xac5029341Ac169fc63F8d610E9e6976E9d3AfC8E',
//   18,
//   'DAI',
//   'Dai stable coin'
// )
// export const USDT_CRAT = new Token(
//   SupportedChainId.CRAT,
//   '0x55d398326f99059fF775485246999027B3197955',
//   18,
//   'USDT',
//   'Tether USD'
// )
// export const USDT_CRAT_TESTNET = new Token(
//   SupportedChainId.CRAT_TESTNET,
//   '0x6D488c820A58c9867D1a2BdfC1787A4090E92E69',
//   18,
//   'USDT',
//   'Tether USD'
// )
// export const BTCB_CRAT = new Token(
//   SupportedChainId.CRAT,
//   '0x7130d2A12B9BCbFAe4f2634d864A1Ee1Ce3Ead9c',
//   18,
//   'BTCB',
//   'BTCB Token'
// )
// export const BTCB_CRAT_TESTNET = new Token(
//   SupportedChainId.CRAT_TESTNET,
//   '0x0c12207ABd905f40045DF836DE14Cf6f3b80327f',
//   18,
//   'BTCB',
//   'BTCB'
// )

export const WRAPPED_NATIVE_CURRENCY: { [chainId: number]: Token | undefined } = {
  [SupportedChainId.CRAT]: new Token(
    SupportedChainId.CRAT,
    '0x0aC3c2fA74b47F16B9eB63dE583aD8261af5d798',
    18,
    'WCRAT',
    'Wrapped CRAT'
  ),
  [SupportedChainId.CRAT_TESTNET]: new Token(
    SupportedChainId.CRAT_TESTNET,
    '0x0aC3c2fA74b47F16B9eB63dE583aD8261af5d798',
    18,
    'WCRAT',
    'Wrapped CRAT'
  ),
}

// function isCrat(chainId: number): chainId is SupportedChainId.CRAT {
//   return chainId === SupportedChainId.CRAT
// }
//
// class CratNativeCurrency extends NativeCurrency {
//   equals(other: Currency): boolean {
//     return other.isNative && other.chainId === this.chainId
//   }
//
//   get wrapped(): Token {
//     if (!isCrat(this.chainId)) throw new Error('Not crat')
//     const wrapped = WRAPPED_NATIVE_CURRENCY[this.chainId]
//     invariant(wrapped instanceof Token)
//     return wrapped
//   }
//
//   public constructor(chainId: number) {
//     if (!isCrat(chainId)) throw new Error('Not crat')
//     super(chainId, 18, 'CRAT', 'CRAT')
//   }
// }

function isCratTestnet(chainId: number): chainId is SupportedChainId.CRAT_TESTNET {
  return chainId === SupportedChainId.CRAT_TESTNET
}

class CratTestnetNativeCurrency extends NativeCurrency {
  equals(other: Currency): boolean {
    return other.isNative && other.chainId === this.chainId
  }

  get wrapped(): Token {
    if (!isCratTestnet(this.chainId)) throw new Error('Not crat testnet')
    const wrapped = WRAPPED_NATIVE_CURRENCY[this.chainId]
    invariant(wrapped instanceof Token)
    return wrapped
  }

  public constructor(chainId: number) {
    if (!isCratTestnet(chainId)) throw new Error('Not crat testnet')
    super(chainId, 18, 'tCRAT', 'tCRAT')
  }
}

class ExtendedEther extends Ether {
  public get wrapped(): Token {
    const wrapped = WRAPPED_NATIVE_CURRENCY[this.chainId]
    if (wrapped) return wrapped
    throw new Error(`Unsupported chain ID: ${this.chainId}`)
  }

  private static _cachedExtendedEther: { [chainId: number]: NativeCurrency } = {}

  public static onChain(chainId: number): ExtendedEther {
    return this._cachedExtendedEther[chainId] ?? (this._cachedExtendedEther[chainId] = new ExtendedEther(chainId))
  }
}

const cachedNativeCurrency: { [chainId: number]: NativeCurrency | Token } = {}
export function nativeOnChain(chainId: number): NativeCurrency | Token {
  if (cachedNativeCurrency[chainId]) return cachedNativeCurrency[chainId]
  let nativeCurrency: NativeCurrency | Token
  // if (isCrat(chainId)) {
  //   nativeCurrency = new CRATNativeCurrency(chainId)
  // } else
  if (isCratTestnet(chainId)) {
    nativeCurrency = new CratTestnetNativeCurrency(chainId)
  } else {
    nativeCurrency = ExtendedEther.onChain(chainId)
  }
  return (cachedNativeCurrency[chainId] = nativeCurrency)
}

export const TOKEN_SHORTHANDS: { [shorthand: string]: { [chainId in SupportedChainId]?: string } } = {
  USDC: {
    // [SupportedChainId.CRAT]: '',
    [SupportedChainId.CRAT_TESTNET]: USDC_CRAT_TESTNET.address,
  },
}
